import React, { Component } from "react";
import "./headerStyle.css"
import "./headerMain.js"
import LogoImage from "../../images/logo-default-light-200x36.png"

class HeaderComponent extends Component {
    state = { 
        navBarMode : this.props.navBarMode
     }

    render() { 
        return (<div>{this.getNavBar()}</div>);
    }

    getNavBar(){
        if(this.state.navBarMode === "main")
            return this.getMainPageNavar();
        else return this.getOtherPageNavbar();
    }

    scrollToElement = (elementId) => {
      const element = document.querySelector(elementId);
      element.scrollIntoView({behavior:"smooth", block: "center", inline:"center"});
    }

    getMainPageNavar(){
        return <header className="site-navbar site-navbar-target bg-white" role="banner">
        <div className="container">
          <div className="row align-items-center position-relative">
      
            <div className="col-lg-5">
              <nav className="site-navigation text-right ml-auto " role="navigation">
                <ul className="site-menu main-menu js-clone-nav ml-auto d-none d-lg-block">
                  <li><a onClick={()=>this.scrollToElement("#mainsection")} className="nav-link">Početna</a></li>
                  <li><a onClick={()=>this.scrollToElement("#onama")} className="nav-link">O nama</a></li>
                </ul>
              </nav>
            </div>
            <div className="col-lg-2 text-center">
              <div className="site-logo">
                <a href="/"><img src={LogoImage} alt="" width="125" height="125" /></a>
              </div>
      
              <div className="ml-auto toggle-button d-inline-block d-lg-none" style={{marginTop:"45px"}}>
                <span className="site-menu-toggle py-5  text-black">
                    <div className="dropdown show">
                      <a className="btn btx-sm btn-primary btn-default nav-link dropdown-toggle" href=""
                        id="dropdownMenuLinkMobile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Zakazivanje
                      </a>
                      <div className="dropdown-menu" aria-labelledby="dropdownMenuLinkMobile">
                        <a className="dropdown-item" href="/zakazivanje">Zakaži termin</a>
                        <a className="dropdown-item" href="/mojitermini">Moji zakazani termini</a>
                      </div>
                    </div>
                </span>
              </div>
            </div>
            <div className="col-lg-5">
              <nav className="site-navigation text-left mr-auto " role="navigation">
                <ul className="site-menu main-menu js-clone-nav ml-auto d-none d-lg-block">
                  <li><a onClick={()=>this.scrollToElement("#proizvodi")} className="nav-link">Proizvodi</a></li>
                  <li><a onClick={()=>this.scrollToElement("#lokacija")} className="nav-link">Kontakt</a></li>
                  <li>
                    <div className="dropdown show">
                      <a className="btn btx-sm btn-primary btn-default nav-link dropdown-toggle" href=""
                        id="dropdownMenuLinkDesktop" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Zakazivanje
                      </a>
      
                      <div className="dropdown-menu" aria-labelledby="dropdownMenuLinkDesktop">
                        <a className="dropdown-item" href="/zakazivanje">Zakaži termin</a>
                        <a className="dropdown-item" href="/mojitermini">Moji zakazani termini</a>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
      
      
          </div>
        </div>
      
      </header>
    };

    getOtherPageNavbar(){
        return <header className="site-navbar site-navbar-target bg-white" role="banner">
        <div className="container">
          <div className="row align-items-center position-relative">
            <div className="col-xs-12  text-center">
                <a href="/"><img src={LogoImage} alt="" width="125" height="125" /></a>
            </div>
          </div>
        </div>
      </header>
    };

}
 
export default HeaderComponent;